/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_Li6Inputs */

const en_guide_json_schema_s2_li6 = /** @type {(inputs: Guide_Json_Schema_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>pattern</strong>: Validates a string against a regular expression`)
};

const ko_guide_json_schema_s2_li6 = /** @type {(inputs: Guide_Json_Schema_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>pattern</strong>: 정규 표현식에 대해 문자열을 유효성 검사`)
};

const ja_guide_json_schema_s2_li6 = /** @type {(inputs: Guide_Json_Schema_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>pattern</strong>: 正規表現に対して文字列を検証`)
};

/**
* | output |
* | --- |
* | "<strong>pattern</strong>: Validates a string against a regular expression" |
*
* @param {Guide_Json_Schema_S2_Li6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_li6 = /** @type {((inputs?: Guide_Json_Schema_S2_Li6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_Li6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_li6(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_li6(inputs)
	return ja_guide_json_schema_s2_li6(inputs)
});